import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';

const InfosModal = () => {
  const { t } = useTranslation();

  const [openInfosModal, setOpenInfosModal] = useState(true);

  return (
    <>
      <Modal
        centered
        style={{ top: 20 }}
        open={openInfosModal}
        onCancel={() => {
          setOpenInfosModal(false);
        }}
        width={550}
        footer={[
          <div style={{ textAlign: 'center', fontWeight: 700 }}>
            <Button
              onClick={() => setOpenInfosModal(false)}
              type="primary"
              style={{
                width: 'auto',
                padding: '4px 15px'
              }}
            >
              {t(`modal.understood`)}
            </Button>
          </div>
        ]}
      >
        <p>{t(`modal.broker_compliance_text`)}</p>
      </Modal>
    </>
  );
};

InfosModal.propTypes = {
  contract: PropTypes.shape({
    amendment: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.string,
    payment_type: PropTypes.string,
    contract_signed: PropTypes.bool
  }).isRequired,
  form: PropTypes.shape({
    resetFields: PropTypes.func
  }).isRequired
};

export default InfosModal;
